<script>
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Portlet from '@src/components/portlet'
export default {
  
  components: { Layout, PageHeader, Portlet }
}
</script>
<template>
  <Layout>
    <router-view></router-view>
  </Layout>
</template>
